export default "__VITE_PUBLIC_ASSET__70a068ae__"